import { Controller } from "@hotwired/stimulus"
function getCsrfToken() {
  const el = document.querySelector('meta[name="csrf-token"]')
  return el && el.content
}

async function postJson(url, data) {
  return fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken()
    },
    body: JSON.stringify(data)
  })
}
export default class extends Controller {
  static targets = [
    "overlay",
    "cartItems", // Pour le slider
    "totalDisplay",
    "subtotalDisplay",
    "deliveryDisplay",
    "cartCount",
    "cartPageItems", // Pour le tableau de la page panier
    "subtotalPageDisplay", // Pour le total de la page panier
    "deliveryPageDisplay", // Pour le total de la page panier
    "totalPageDisplay", // Pour le total de la page panier
  ]


  connect() {
    this.openValue = false // Le slider est fermé par défaut
    this.loadCartFromLocalStorage() // Charge le panier au démarrage
    this.updateCartCount() // Met à jour le compteur dans la navbar
    // NOUVEAU : Vérifie si nous sommes sur la page du panier et déclenche le rendu
    if (window.location.pathname === "/vitrine/cart") {
      this.renderCartPageItems()
    }
    window.addEventListener('cart-updated', this.handleCartUpdate.bind(this))
  }

  disconnect() {
    window.removeEventListener('cart-updated', this.handleCartUpdate.bind(this))
  }

  handleCartUpdate() {
    this.loadCartFromLocalStorage()
    this.updateCartCount()
    if (this.hasOverlayTarget) {
      if (this.openValue) {
        this.renderCartSliderItems()
      } else {
        this.toggle()
      }
    }
    if (this.hasCartPageItemsTarget) {
      this.renderCartPageItems()
    }
  }

  // --- Gestion de l'ouverture/fermeture du slider ---
  toggle() {
    // Vérifie si le slider existe avant de l'ouvrir
    if (!this.hasOverlayTarget) {
      return
    }

    this.openValue = !this.openValue
    if (this.openValue) {
      this.overlayTarget.classList.add("is-open")
      this.renderCartSliderItems() // Affiche les articles du panier quand le slider s'ouvre
    } else {
      this.overlayTarget.classList.remove("is-open")
    }
  }

  close() {
    if (!this.hasOverlayTarget) return

    this.openValue = false
    this.overlayTarget.classList.remove("is-open")
  }

  // --- Gestion des articles du panier (localStorage) ---
  // Charge le panier depuis le localStorage
  loadCartFromLocalStorage() {
    try {
      const cartData = localStorage.getItem("cart")
      this.cartItems = cartData ? JSON.parse(cartData) : []
    } catch (e) {
      console.error("Failed to load cart from localStorage:", e)
      this.cartItems = []
    }
  }

  // Sauvegarde le panier dans le localStorage
  saveCartToLocalStorage() {
    try {
      localStorage.setItem("cart", JSON.stringify(this.cartItems))
    } catch (e) {
      console.error("Failed to save cart to localStorage:", e)
    }
  }

  // Action pour ajouter un parfum au panier
addToCart(event) {
  event.preventDefault()
  event.stopPropagation()

  const parfumId = event.currentTarget.dataset.parfumId
  const parfumName = event.currentTarget.dataset.parfumName
  const parfumPrice = Number.parseFloat(event.currentTarget.dataset.parfumPrice)
  const parfumSize = event.currentTarget.dataset.parfumSize || '10ml' // NOUVEAU
  const parfumImageUrl = event.currentTarget.dataset.parfumImageUrl || "/placeholder.svg?height=50&width=50&text=P"


  if (!parfumId || !parfumName || isNaN(parfumPrice)) {
    console.error("Missing or invalid parfum data for adding to cart.")
    return
  }

  // CHANGEMENT: Chercher par ID ET TAILLE (pas juste par ID)
  const existingItem = this.cartItems.find(
    (item) => item.id === parfumId && item.size === parfumSize
  )

  if (existingItem) {
    existingItem.quantity += 1
  } else {
    this.cartItems.push({
      id: parfumId,
      name: parfumName,
      size: parfumSize, // NOUVEAU
      price: parfumPrice,
      imageUrl: parfumImageUrl,
      quantity: 1,
    })
  }

  this.saveCartToLocalStorage()
  window.dispatchEvent(new Event('cart-updated'))
  this.updateCartCount()

  if (this.hasCartItemsTarget) {
    this.renderCartSliderItems()
  }

  if (this.hasCartPageItemsTarget) {
    this.renderCartPageItems()
  }

  if (this.hasOverlayTarget) {
    if (!this.openValue) {
      this.toggle()
    } else {
      this.renderCartSliderItems()
    }
  }
}

  // NOUVELLE MÉTHODE : Notification quand le slider n'est pas disponible
  showAddToCartNotification(parfumName) {
    // Crée une notification temporaire
    const notification = document.createElement("div")
    notification.innerHTML = `
      <div style="
        position: fixed;
        top: 20px;
        right: 20px;
        background: #28a745;
        color: white;
        padding: 15px 20px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        z-index: 9999;
        font-family: Arial, sans-serif;
        font-size: 14px;
        max-width: 300px;
        animation: slideIn 0.3s ease-out;
      ">
        <strong>Ajouté au panier !</strong><br>
        ${parfumName}
      </div>
      <style>
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      </style>
    `

    document.body.appendChild(notification)

    // Supprime la notification après 3 secondes
    setTimeout(() => {
      notification.style.animation = "slideIn 0.3s ease-out reverse"
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification)
        }
      }, 300)
    }, 3000)
  }

  // NOUVELLE MÉTHODE : Acheter maintenant
  buyNow(event) {
    event.preventDefault()
    event.stopPropagation()

    const parfumId = event.currentTarget.dataset.parfumId
    const quantity = event.currentTarget.dataset.quantity || 1
    const parfumSize = event.currentTarget.dataset.parfumSize || '10ml'

    if (!parfumId) {
      console.error("Missing parfum ID for buy now.")
      return
    }

    // CETTE LIGNE EST CRITIQUE!
    window.location.href = `/vitrine/checkout?parfum_id=${parfumId}&quantity=${quantity}&parfum_size=${encodeURIComponent(parfumSize)}`
  }

  // NOUVEAU : Méthode pour mettre à jour la quantité d'un article
updateQuantity(event) {
  event.preventDefault()
  event.stopPropagation()

  const parfumId = event.currentTarget.dataset.parfumId
  const parfumSize = event.currentTarget.dataset.parfumSize // NOUVEAU
  let newQuantity

  if (event.currentTarget.dataset.actionType === "increment") {
    newQuantity = this.cartItems.find((item) => item.id === parfumId && item.size === parfumSize).quantity + 1
  } else if (event.currentTarget.dataset.actionType === "decrement") {
    newQuantity = this.cartItems.find((item) => item.id === parfumId && item.size === parfumSize).quantity - 1
  } else if (event.currentTarget.tagName === "INPUT") {
    newQuantity = Number.parseInt(event.currentTarget.value, 10)
    if (isNaN(newQuantity) || newQuantity < 0) {
      newQuantity = 1
    }
  }

  const itemIndex = this.cartItems.findIndex((item) => item.id === parfumId && item.size === parfumSize)

  if (itemIndex > -1) {
    if (newQuantity <= 0) {
      this.cartItems.splice(itemIndex, 1)
    } else {
      this.cartItems[itemIndex].quantity = newQuantity
    }

    this.saveCartToLocalStorage()
    window.dispatchEvent(new Event('cart-updated'))
    this.updateCartCount()

    if (this.hasCartItemsTarget) {
      this.renderCartSliderItems()
    }
    if (this.hasCartPageItemsTarget) {
      this.renderCartPageItems()
    }
  }
}

  // Action pour supprimer un article du panier (utilisée par le bouton "Supprimer")
removeItem(event) {
  event.preventDefault()
  event.stopPropagation()

  const parfumIdToRemove = event.currentTarget.dataset.parfumId
  const parfumSizeToRemove = event.currentTarget.dataset.parfumSize // NOUVEAU
  
  this.cartItems = this.cartItems.filter(
    (item) => !(item.id === parfumIdToRemove && item.size === parfumSizeToRemove)
  )

  this.saveCartToLocalStorage()
  window.dispatchEvent(new Event('cart-updated'))
  this.updateCartCount()

  if (this.hasCartItemsTarget) {
    this.renderCartSliderItems()
  }
  if (this.hasCartPageItemsTarget) {
    this.renderCartPageItems()
  }

}

  // --- Rendu du panier (pour le slider) ---
renderCartSliderItems() {
  if (!this.hasCartItemsTarget) {
    return
  }

  if (this.cartItems.length === 0) {
    this.cartItemsTarget.innerHTML = `<p class="cart-slider-empty-message">Votre panier est vide.</p>`
    this.updateSliderTotals(0, 0, 0)
    return
  }

  const itemsHtml = this.cartItems
    .map(
      (item) => `
    <div class="cart-slider-item">
      <img src="${item.imageUrl}" alt="${item.name}" class="cart-slider-item-image">
      <div class="cart-slider-item-info">
        <h4 class="cart-slider-item-name">${item.name}</h4>
        <p class="cart-slider-item-volume">${item.size} × ${item.quantity}</p>
        <p class="cart-slider-item-price">${this.formatCurrency(item.price * item.quantity)}</p>
      </div>
      <button class="cart-slider-item-remove" 
              data-action="click->cart#removeItem" 
              data-parfum-id="${item.id}"
              data-parfum-size="${item.size}"
              aria-label="Supprimer ${item.name} (${item.size})">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
      </button>
    </div>
  `,
    )
    .join("")

  this.cartItemsTarget.innerHTML = itemsHtml
  this.calculateAndDisplayTotals()
}

  // --- Rendu du panier (pour la page dédiée) ---
renderCartPageItems() {
  if (!this.hasCartPageItemsTarget) return

  if (this.cartItems.length === 0) {
    this.cartPageItemsTarget.innerHTML = `
      <tr>
        <td colspan="4" class="cart-table-empty-message">Votre panier est vide.</td>
      </tr>
    `
    this.updatePageTotals(0, 0, 0)
    return
  }

  const itemsHtml = this.cartItems
    .map(
      (item) => `
    <tr>
      <td class="cart-table-cell" data-label="Produit">
        <div class="cart-item-info-cell">
          <img src="${item.imageUrl}" alt="${item.name}" class="cart-item-image">
          <div>
            <span class="cart-item-name">${item.name}</span>
            <p class="cart-item-volume">${item.size}</p>
          </div>
        </div>
      </td>
      <td class="cart-table-cell" data-label="Quantité">
        <div class="cart-item-quantity-controls">
          <button class="quantity-btn" data-action="click->cart#updateQuantity" data-action-type="decrement" data-parfum-id="${item.id}" data-parfum-size="${item.size}">-</button>
          <input type="number" value="${item.quantity}" min="1" class="quantity-input" data-parfum-id="${item.id}" data-parfum-size="${item.size}" data-action="change->cart#updateQuantity:debounce(300)">
          <button class="quantity-btn" data-action="click->cart#updateQuantity" data-action-type="increment" data-parfum-id="${item.id}" data-parfum-size="${item.size}">+</button>
        </div>
      </td>
      <td class="cart-table-cell cart-item-price" data-label="Prix Unitaire">
        ${this.formatCurrency(item.price)}
      </td>
      <td class="cart-table-cell cart-item-actions" data-label="Actions">
        <button class="cart-item-remove-btn" data-action="click->cart#removeItem" data-parfum-id="${item.id}" data-parfum-size="${item.size}" aria-label="Supprimer ${item.name} (${item.size})">
          Supprimer
        </button>
      </td>
    </tr>
  `,
    )
    .join("")

  this.cartPageItemsTarget.innerHTML = itemsHtml
  this.calculateAndDisplayTotals()
}

  // Met à jour le compteur dans la navbar
  updateCartCount() {
    if (this.hasCartCountTarget) {
      // Calcule le nombre total d'articles (somme des quantités)
      const totalItems = this.cartItems.reduce((sum, item) => sum + item.quantity, 0)
      this.cartCountTarget.textContent = totalItems.toString()
      this.cartCountTarget.classList.add("animate-pop")
      setTimeout(() => this.cartCountTarget.classList.remove("animate-pop"), 300)
    }
  }

  // --- Calcul et affichage des totaux ---
static values = { shippingFee: Number, open: Boolean }

calculateAndDisplayTotals() {
    const subtotal = this.cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0)
    const deliveryFee = subtotal >= 250 ? 0 : (this.shippingFeeValue || 8) // Utilise shippingFeeValue
    const total = subtotal + deliveryFee
    this.updateSliderTotals(subtotal, deliveryFee, total)
    this.updatePageTotals(subtotal, deliveryFee, total)
  }

  updateSliderTotals(subtotal, deliveryFee, total) {
    if (this.hasSubtotalDisplayTarget) {
      this.subtotalDisplayTarget.textContent = this.formatCurrency(subtotal)
    }
    if (this.hasDeliveryDisplayTarget) {
      this.deliveryDisplayTarget.textContent = this.formatCurrency(deliveryFee)
    }
    if (this.hasTotalDisplayTarget) {
      this.totalDisplayTarget.textContent = this.formatCurrency(total)
    }
  }

  updatePageTotals(subtotal, deliveryFee, total) {
    if (this.hasSubtotalPageDisplayTarget) {
      this.subtotalPageDisplayTarget.textContent = this.formatCurrency(subtotal)
    }
    if (this.hasDeliveryPageDisplayTarget) {
      this.deliveryPageDisplayTarget.textContent = this.formatCurrency(deliveryFee)
    }
    if (this.hasTotalPageDisplayTarget) {
      this.totalPageDisplayTarget.textContent = this.formatCurrency(total)
    }
  }

  // --- Navigation et Actions ---
  viewCartPage() {
    this.close() // Ferme le slider
    window.location.href = "/vitrine/cart" // Redirige vers la page du panier
  }

  // MODIFIÉ : Redirige vers checkout au lieu d'afficher une alerte
  orderCart() {
    if (this.cartItems.length === 0) {
      alert("Votre panier est vide !")
      return
    }

    // Encode les données du panier pour les passer en paramètre
    const cartData = encodeURIComponent(JSON.stringify(this.cartItems))
    window.location.href = `/vitrine/checkout?cart_items=${cartData}`
  }

  // --- Fonctions utilitaires ---
  formatCurrency(amount) {
    return new Intl.NumberFormat("fr-TN", { style: "currency", currency: "TND" }).format(amount)
  }
}
